module.exports = __webpack_public_path__ + "static/media/es-ES.d84d660b.png";